module.exports = __webpack_public_path__ + "static/media/doc.f98808e8.svg";